import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledMenu = styled.div<{ isIconClose: boolean }>`
  cursor: pointer;
  padding: ${spaceMixin('xs')};

  svg {
    color: ${token('colors.brand')};
    font-size: ${(props) => (props.isIconClose ? '20px' : '24px')};
  }
`;
